import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';

export enum NotificationType {
  HIRING_HERO_PROGRESS_UPDATE = 'hiring_progress_update',
  USER_PROFILE_REPORTED_HIRE = 'user_profile_reported_hire',
  HIRING_HERO_EARNED = 'hiring_hero_earned',
  NOTES_TUTORIAL = 'notes_tutorial',
  MULTIPLE_APPLICANTS_SELECTION_TUTORIAL = 'multiple_applicants_selection_tutorial',
  SHOW_HIRING_SURVEY = 'show_hiring_survey',
}

/**
 * Relationship classes
 */
export class SystemNotificationAttributes {
  id: string = null;
  createdAt: number = null;
  updatedAt: number = null;
  startDate: number = null;
  endDate: number = null;
  seenAt: number = null;
  notificationType: NotificationType = null;
  metadata: {
    user_profile_id?: string;
    status?: string;
  }[] = null;
}

export class SystemNotificationBelongsTo {}

export class SystemNotificationHasOne {}

export class SystemNotificationHasMany {}

/**
 * Utility interfaces
 */
export interface SystemNotificationMethods {}

export interface SystemNotificationInterface
  extends SystemNotificationAttributes,
    SystemNotificationBelongsTo,
    SystemNotificationHasOne,
    SystemNotificationHasMany,
    SystemNotificationType {}

type SystemNotificationType = GConstructor<SystemNotificationInterface>;

export interface SystemNotificationResource
  extends Base<SystemNotificationAttributes>,
    SystemNotificationInterface,
    SystemNotificationMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<SystemNotificationAttributes>({
    queryName: 'system_notifications',
    className: 'SystemNotification',
    AttributesClass: SystemNotificationAttributes,
    BelongsToClasses: [
      {
        Klass: SystemNotificationBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: SystemNotificationHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: SystemNotificationHasMany,
      },
    ],
  });

export const SystemNotificationResourceClass = <TBase extends SystemNotificationType>(
  BaseConstructor: TBase,
) => class extends BaseConstructor implements SystemNotificationMethods {};

export class SystemNotificationResource extends ClassExtender<SystemNotificationInterface>(
  BaseClass,
  SystemNotificationResourceClass,
) {}

/**
 * Resource instance
 */
export const SystemNotification = APILibrary.createResource<SystemNotificationResource>(
  SystemNotificationResource,
);
